import React, { useEffect, useState } from 'react'
import { Card, CardFooter, CardHeader, Container, Row, Table, UncontrolledTooltip } from 'reactstrap';
import TransactionModal from "models/transaction"
import { Link, useLocation } from 'react-router-dom';
import moment from 'moment';
import Loader from "components/loader/Loader";

const AllTransaction = () => {
  const location = useLocation();
  const[data, setData]= useState();
  const[fromdate,setFromdate]=useState();
  const[todate,setTodate]=useState();
  const[mode,setMode]=useState();
  const [isLoading, setIsLoading] = useState(true);
  

  console.log("kkkkk",data);
  const alltrancsaction = async()=>{
    setIsLoading(true);
    TransactionModal.GetAll(fromdate,todate,mode)
    .then((responce)=>{
      setData(responce);
      setIsLoading(false)
    })
    .catch((error)=>{
      console.log("error",error)
    })
  }

  useEffect(()=>{
alltrancsaction();
  },[location ,fromdate,todate,mode])
  return (
    <div className="pt-7 px-4">
    <Row>
    <div className="col">
      <Card className="shadow">
        <CardHeader className="border-0 d-flex justify-content-between ">
          <h3 className="mb-0">All Transaction</h3>
          <div className='d-flex'>
            <div className='d-flex'>
              <div className="d-flex flex-column mr-2">
                <span style={{fontSize:"14px",color:"gray"}}>From</span>
                <input  style={{borderWidth:"1px",borderRadius:"5px",padding: "1px 1px"}} type='date' onChange={(e)=>{setFromdate(e.target.value)}}/></div>
              <div className="d-flex flex-column mr-2 " >
              <span style={{fontSize:"14px",color:"gray"}}>To</span>
                <input  style={{borderWidth:"1px",borderRadius:"5px",padding: "1px 1px"}} type='date' onChange={(e)=>{setTodate(e.target.value)}}/></div>
              </div>
            <div className="d-flex flex-column">
              <span style={{fontSize:"14px",color:"gray"}}>Mode</span>
            <select style={{borderWidth:"1px",borderRadius:"5px",padding: "2px 1px"}} onChange={(e)=>{setMode(e.target.value)}}>
            <option value="">Select</option>
            <option value="Cash">Cash</option>
            <option value="Neft/Imps">Neft/Imps</option>
            <option value="Upi">Upi</option>
            <option value="Others">Others</option>
            </select>
            </div>

          </div>
          </CardHeader>
          <Table className="align-items-center table-flush" responsive>
              <thead className="thead-light">
                <tr>
                  <th scope="col">#</th>
                  {/* <th scope="col">CLASS ID</th> */}
                  <th scope="col"> Timestamp</th>
                  <th scope="col"> User</th>
                  <th scope="col">Update Type</th>
                  <th scope="col">Method</th>
                  {/* <th scope="col">Transaction Id</th> */}

                  <th scope="col">Payment type
                  </th>
                  <th scope="col">Credit Amount</th>
                  <th scope="col">Debit  Amount</th>
                 {/* <th scope="col">transaction_id</th>*/}
                  {/*<th scope="col">Action</th>*/}
                </tr>
              </thead>

              <tbody>
              {
  isLoading ? (
    <tr>
      <td colSpan={9} className="text-center align-middle py-4">
        Please wait...
        <Loader />
      </td>
    </tr>
  ) : data?.data?.data?.length > 0 ? (
    data?.data?.data?.map((item, index) => {
      return (
        <tr key={item._id} style={{ cursor: "pointer" }}>
          <td>{index + 1}</td>
          <td>
            <div style={{ display: "flex", flexDirection: "column" }}>
              <div className='d-flex flex-column'>
                <span>{item?.date || "-"}</span>
                <span style={{ fontSize: "11px", color: "grey" }}>
                  {moment(item.createdAt).format('HH:mm A')}
                </span>
              </div>
            </div>
          </td>
          <td>{item?.user?.first_name || "-"} {item?.user?.last_name || "-"}</td>
          <td>{item?.payment_for || "-"}</td>
          <td>{item?.pay_mode || "-"}</td>
          <td>{item?.payment_type || "-"}</td>
          <td>{item?.payment_type === "Credited" && item?.amount_paid || "-"}</td>
          <td>{item?.payment_type === "Debited" && item?.amount_paid || "-"}</td>
        </tr>
      );
    })
  ) : (
    <tr style={{ textAlign: "center" }}>
      <td colSpan="9" style={{ verticalAlign: "middle" }}>
        No data found
      </td>
    </tr>
  )
}
              </tbody>
            </Table>
            <CardFooter className="py-4">
              {/* <TablePagination
                totalPages={parseInt(dataList?.meta?.total_page)}
                currentPage={parseInt(dataList?.meta?.current_page)}
                pageUrl="/admin/messages?"
              /> */}
            </CardFooter>
          </Card>
          </div>
          </Row>
    </div>
  )
}

export default AllTransaction
